import PaginationLeftArrowIcon from 'assets/icons/paginationLeftArrowCircle.svg';
import PaginationRightArrowIcon from 'assets/icons/paginationRightArrowCircle.svg';
import { type TableFooterProps } from 'components/table/base/tableFooter';

export type PassedTableFooterProps = Omit<TableFooterProps, 'onPageSizeSelect' | 'totalItemsCount' | 'siblingCount' | 'pageSize'>;

interface TablePaginationProps {
  passed: PassedTableFooterProps;
  paginationRange: (string | number)[];
  onNext: () => void;
  onPrevious: () => void;
}

function TablePagination(props: TablePaginationProps) {
  const {
    totalPageCount,
    pageIndex,
    onPaginate,
    showFirstLastButton,
  } = props.passed;

  const {
    paginationRange,
    onNext,
    onPrevious,
  } = props;

  return (
    totalPageCount > 1 ? (
      <div className="ct_tablePagination">
        <div className="ct_tablePagination-range">
          {!!showFirstLastButton && totalPageCount > 2 && (
            <button
              className="ct_tablePagination-btn _first"
              type="button"
              onClick={() => onPaginate(0)}
              disabled={pageIndex < 1}
            >
              {'<<'}
            </button>
          )}
          <button
            className="ct_tablePagination-btn _prev"
            type="button"
            onClick={() => onPrevious()}
            disabled={pageIndex < 1}
          >
            <PaginationLeftArrowIcon />
          </button>
          {!!paginationRange
            && paginationRange.length
            && paginationRange.map((current, index) => {
              if (current === '...') {
                return (
                  <div className="ct_tablePagination-dots" key={index}>
                    ...
                  </div>
                );
              }

              return (
                <button
                  className={`ct_tablePagination-btn${
                    current === pageIndex + 1 ? ' _active' : ''
                  }`}
                  type="button"
                  key={index}
                  onClick={() => onPaginate((current as number) - 1)}
                >
                  {current}
                </button>
              );
            })}
          <button
            className="ct_tablePagination-btn _next"
            type="button"
            onClick={() => onNext()}
            disabled={pageIndex === totalPageCount - 1}
          >
            <PaginationRightArrowIcon />
          </button>
          {!!showFirstLastButton && totalPageCount > 2 && (
            <button
              className="ct_tablePagination-btn _last"
              type="button"
              onClick={() => onPaginate(totalPageCount - 1)}
              disabled={pageIndex === totalPageCount - 1}
            >
              {'>>'}
            </button>
          )}
        </div>
      </div>
    ) : null
  );
}

export default TablePagination;
